import React from "react";
import { Link } from "react-router-dom";
const PrivacyPage = () => {
  return (
    <>
      <div className="hidden lg:block privacy-policy">
        <div className="w-[15.5] flex flex-col pt-[20vh]">
          <div className="text-[2.6vw] font-semibold text-white">
            Privacy Policy
          </div>
          <div className="text-white flex gap-3 justify-center text-[1vw] font-urbanist">
            <Link to="/">
              <button className="hover:text-white hover:scale-110 duration-150">
                Home
              </button>
            </Link>
            /
            <button className="hover:text-white hover:scale-110 duration-150">
              Privacy Policy
            </button>
          </div>
        </div>
      </div>

      <div className="font-urbanist text-left bg-white text-black p-[5vw] max-w-[90vw] mx-auto">
        <h1 className="text-[3vw] font-bold mb-[1vw]">
          Privacy Policy for BidCaribbean
        </h1>

        <p className="text-[1.5vw] mb-[3vw]">Last Updated: Mar 17, 2025</p>

        <section className="mb-[3vw] text-[1.5vw]">
          {/* <h2 className="text-[2vw] font-semibold mb-[1vw]">Introduction</h2> */}
          <p className="">
            We, Lux First Choice Cars, a company incorporated under the laws of
            The Bahamas, with our registered address at Marsh Harbour Abaco
            (hereinafter referred to as “we,” “us,” or the “Company”), have
            prepared this Privacy Policy (hereinafter referred to as the
            “Policy”) to demonstrate our commitment to protecting the privacy
            and personal data of our customers and visitors to
            www.bidcaribbean.co (hereinafter referred to as the “Website”).
          </p>
          <p className="">
            This Policy outlines how we collect, use, store, and share your{" "}
            <strong>Personal Data</strong> (as defined below) when you use our
            Website or services. It also explains your rights under applicable
            data protection laws, including the{" "}
            <strong> Data Protection Act 2021</strong> of The Bahamas and other
            relevant Caribbean legislation.
          </p>
          <p className="">
            By using our Website or services, you agree to the terms of this
            Policy. If you do not agree, please refrain from using our services.
          </p>
        </section>

        {/* 1 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            1. Personal Data Protection Statement
          </h2>
          <p className="">
            We are committed to complying with data protection laws in The
            Bahamas, Turks and Caicos, and other Caribbean jurisdictions where
            we operate. This includes:
          </p>
          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                The Data Protection Act 2021 of The Bahamas, which governs the
                processing of personal data and ensures the rights of data
                subjects.
              </p>
            </li>
            <li>
              <p className="">
                Relevant privacy laws in Turks and Caicos and other Caribbean
                territories.
              </p>
            </li>
          </ol>
          <p className="">
            We do not require you to register or provide Personal Data to browse
            our Website. However, certain services may require you to provide
            Personal Data, and failure to do so may limit your ability to use
            those services.
          </p>
          <p>
            We act as the Data Controller for the purposes of applicable data
            protection laws, meaning we determine the purposes and means of
            processing your Personal Data.
          </p>
        </section>

        {/* 2 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            2. What Personal Data Do We Collect?
          </h2>
          <p className="">
            We may collect and process the following types of Personal Data:
          </p>
          <h3 className="text-[1.8vw] font-semibold">
            (A) Information You Provide:
          </h3>
          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                Name, address, email address, and phone number.
              </p>
            </li>
            <li>
              <p className="">
                Payment information (e.g., credit card details, billing
                address).
              </p>
            </li>
            <li>
              <p className="">
                Identification documents (e.g., passport, driver’s license).
              </p>
            </li>
            <li>
              <p className="">Vehicle information (e.g., VIN number).</p>
            </li>
            <li>
              <p className="">Transaction history and preferences.</p>
            </li>
          </ol>

          <h3 className="text-[1.8vw] font-semibold">
            (B) Information Collected Automatically:{" "}
          </h3>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                IP address, device information (e.g., device type, operating
                system, browser type).
              </p>
            </li>
            <li>
              <p className="">Geolocation data (country, region, city)</p>
            </li>
            <li>
              <p className="">
                Cookies and tracking technologies (see our Cookie Policy for
                details).
              </p>
            </li>
          </ol>

          <h3 className="text-[1.8vw] font-semibold">
            (C) Information from Third Parties:
          </h3>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                Data from social media platforms (e.g., Facebook, Google) if you
                use these to log in.{" "}
              </p>
            </li>
            <li>
              <p className="">
                Data from payment processors (e.g., Stripe, PayPal).
              </p>
            </li>
          </ol>
        </section>

        {/* 3 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            3. How We Use Your Personal Data{" "}
          </h2>
          <p className="">
            We process your Personal Data for the following purposes:
          </p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                To provide and improve our services (e.g., processing
                transactions, customer support).
              </p>
            </li>
            <li>
              <p className="">To personalize your experience on our Website.</p>
            </li>
            <li>
              <p className="">
                To comply with legal and regulatory obligations (e.g., tax
                reporting, fraud prevention).
              </p>
            </li>
            <li>
              <p className="">
                For marketing and promotional purposes (with your consent).
              </p>
            </li>
            <li>
              <p className="">
                To analyze Website usage and improve our services.
              </p>
            </li>
          </ol>
        </section>

        {/* 4 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            4. Legal Basis for Processing{" "}
          </h2>
          <p className="">
            We process your Personal Data based on one or more of the following
            legal grounds:
          </p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>Consent: </strong>You have given explicit consent for
                specific processing activities (e.g., marketing communications).{" "}
              </p>
            </li>

            <li>
              <p className="">
                <strong>Contractual Necessity: </strong>Processing is necessary
                to fulfill a contract with you (e.g., processing payments).{" "}
              </p>
            </li>

            <li>
              <p className="">
                <strong>Legal Obligation: </strong>Processing is required to
                comply with applicable laws (e.g., tax reporting).
              </p>
            </li>

            <li>
              <p className="">
                <strong>Legitimate Interests: </strong>Processing is necessary
                for our legitimate business interests (e.g., fraud prevention,
                improving services).
              </p>
            </li>
          </ol>
        </section>

        {/* 5 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            5. Sharing Your Personal Data{" "}
          </h2>
          <p className="">We may share your Personal Data with:</p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>Service Providers:</strong>Third-party vendors who
                assist us in providing services (e.g., payment processors, IT
                support).
              </p>
            </li>

            <li>
              <p className="">
                <strong>Legal Authorities: </strong>When required by law or to
                protect our legal rights (e.g., court orders, fraud prevention).{" "}
              </p>
            </li>

            <li>
              <p className="">
                <strong>Business Transfers: </strong>In the event of a merger,
                acquisition, or sale of assets, your Personal Data may be
                transferred to the new owner.
              </p>
            </li>
          </ol>

          <p className="">
            We do not sell your Personal Data to third parties.
          </p>
        </section>

        {/* 6 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            6. Data Retention{" "}
          </h2>
          <p className="">
            We retain your Personal Data only for as long as necessary to
            fulfill the purposes outlined in this Policy or as required by law.
            For example:
          </p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                Transaction data may be retained for tax and accounting
                purposes.
              </p>
            </li>

            <li>
              <p className="">
                Marketing data will be retained until you withdraw your consent.
              </p>
            </li>
          </ol>
        </section>

        {/* 7 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            7. Your Rights Under Caribbean Data Protection Laws
          </h2>
          <p className="">
            Depending on your jurisdiction, you may have the following rights:
          </p>
          <h2 className="text-[1.8vw] font-semibold mb-[1vw]">
            (A) Under the Bahamas Data Protection Act 2021:
          </h2>
          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                <strong>Right to Access:</strong> Request a copy of your
                Personal Data.
              </p>
            </li>

            <li>
              <p className="">
                <strong>Right to Rectification: </strong> Correct inaccurate or
                incomplete data.
              </p>
            </li>

            <li>
              <p className="">
                <strong>Right to Erasure: </strong>Request deletion of your data
                under certain conditions.
              </p>
            </li>

            <li>
              <p className="">
                <strong>Right to Restrict Processing: </strong>Limit how we use
                your data.
              </p>
            </li>

            <li>
              <p className="">
                <strong>Right to Object: </strong>Object to processing based on
                legitimate interests.
              </p>
            </li>

            <li>
              <p className="">
                <strong>Right to Data Portability: </strong>Request transfer of
                your data to another controller.
              </p>
            </li>
          </ol>

          <h2 className="text-[1.8vw] font-semibold mb-[1vw]">
            (B) Under Turks and Caicos Laws:
          </h2>

          <p className="">
            While Turks and Caicos does not have a comprehensive data protection
            law, we adhere to international best practices and respect your
            rights to privacy and data protection. To exercise your rights,
            please contact us using the details provided below.
          </p>
        </section>

        {/* 8 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            8. Data Security{" "}
          </h2>
          <p className="">
            We implement robust technical and organizational measures to protect
            your Personal Data, including:
          </p>

          <ol className="list-disc pl-[3vw] text-[1.5vw] space-y-[0.5vw]">
            <li>
              <p className="">
                Encryption of sensitive data (e.g., payment information).
              </p>
            </li>
            <li>
              <p className="">Regular security audits and malware scanning.</p>
            </li>
            <li>
              <p className="">
                Access controls to limit who can view your data.
              </p>
            </li>
          </ol>
          <p className="">
            While we strive to protect your data, no method of transmission or
            storage is 100% secure. If a data breach occurs, we will notify you
            and relevant authorities as required by law.{" "}
          </p>
        </section>

        {/* 9 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            9. International Data Transfers
          </h2>
          <p className="">
            If we transfer your Personal Data outside the Caribbean, we will
            ensure adequate safeguards are in place, such as standard
            contractual clauses or adherence to international privacy
            frameworks.
          </p>
        </section>

        {/* 10 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            10. Cookies and Tracking Technologies
          </h2>
          <p className="">
            We use cookies and similar technologies to enhance your experience
            on our Website. A cookie is a text-only string of information that
            we place in your computer's cookie file so that we can remember who
            you are when you revisit www.Bidcaribbean.co website. We may use the
            data generated from cookies to compile statistical data on your use
            of our website. You are not obliged to accept the cookie from us and
            you have the ability to accept or decline cookies by changing the
            settings in your browser. Please see www.cookiecentral.com/faq if
            you require any further information about the placing, use or
            deletion of cookies.{" "}
          </p>
        </section>

        {/* 11 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            11. Children’s Privacy
          </h2>
          <p className="">
            Our services are not intended for individuals under the age of 18.
            We do not knowingly collect Personal Data from minors. If you
            believe a child has provided us with data, please contact us
            immediately.{" "}
          </p>
        </section>

        {/* 12 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">
            12. Changes to This Policy
          </h2>
          <p className="">
            We may update this Policy from time to time. Any changes will be
            posted on our Website, and we will notify you via email if required
            by law.
          </p>
        </section>

        {/* 12 */}
        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[2vw] font-semibold mb-[1vw]">13. Contact Us</h2>
          <p className="">
            If you have any questions or concerns about this Policy please
            contact us electronically or send physical mail.
          </p>
        </section>

        <section className="mb-[3vw] text-[1.5vw]">
          <h2 className="text-[1.5vw] font-semibold ">Lux First Choice Cars</h2>
          <h3>Marsh Harbour Abaco</h3>
          <h3>Phone: 1242-825-9510/1954-737-5889</h3>
          <p className="">Email: customersupport@Bidcaribbean.co</p>
          <p className="">
            For complaints or further assistance, you may also contact the
            relevant data protection authority in your jurisdiction (e.g.,{" "}
            <strong> the Office of the Data Protection Commissioner</strong> in
            The Bahamas).{" "}
          </p>
        </section>
      </div>
    </>
  );
};
export default PrivacyPage;
